module.exports = __webpack_public_path__ + "media/application/images/2023/shapes/02_shape-md-6a50650143b9ebb2c3f1d3d3db08ea5f.png";